import { z } from "zod";

export const forgetPasswordFormSchema = z.object({
  userName: z
    .string()
    .nonempty(`${"components.forgetPasswordForm.login_required"}`),
});

export type TForgetPasswordForm = z.infer<typeof forgetPasswordFormSchema>;
